module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#crime",
      toString: function () {
        return this.url;
      }
    }